'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Storage) {
    return function (Component) {
        return connectFabric(Component, Storage);
    };
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _eventEmitter = require('../Base/views/eventEmitter.c');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _lodash = require('lodash.uniqueid');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.throttle');

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var onCollectionChangeDefault = function onCollectionChangeDefault() {
    return {
        __connectIterationId: (0, _lodash2.default)('connectIterationId')
    };
};

var ConnectCollection = function (_EventEmitter) {
    _inherits(ConnectCollection, _EventEmitter);

    function ConnectCollection() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ConnectCollection);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectCollection.__proto__ || Object.getPrototypeOf(ConnectCollection)).call.apply(_ref, [this].concat(args))), _this), _this._handleStorageChange = function () {
            _this._updateStorage();
            return _this;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectCollection, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.storage && this.Storage !== this.props.storage) {
                this.Storage = this.props.storage;
                this._rebind();
                this._updateStorage();
            }

            return this;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Class properties of child class are assign after instance creating
            // Storage, attribute, ComponentToWrap are empty in ConnectModel constructor
            if (!this.Storage && this.props.storage) {
                this.Storage = this.props.storage;
            }

            this.setState(this._getState(), this._bind);

            return this;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._unbind();
            return this;
        }
    }, {
        key: 'render',
        value: function render() {
            if (typeof this.ComponentToWrap === 'function') {
                var Component = this.ComponentToWrap;
                // this.props.storage is assign to this.Storage in cdm and cdu
                // not constructor because of Storage is not defined yet
                // not cwn because of deprecation
                // this.props.storage is passed to children only for initial render before cmd processing
                return _react2.default.createElement(Component, _extends({}, this.props, { collection: this.Storage || this.props.storage }));
            } else {
                return null;
            }
        }
    }, {
        key: '_getState',
        value: function _getState() {
            return onCollectionChangeDefault();
        }
    }, {
        key: '_bind',
        value: function _bind() {
            if (this.Storage) {
                // коллекция тригерит слишком много событий при изменеии чего либо
                this.listenTo(this.Storage, 'all', (0, _lodash4.default)(this._handleStorageChange, 50, { leading: false }));
            }

            return this;
        }
    }, {
        key: '_unbind',
        value: function _unbind() {
            if (this.Storage) {
                this.stopListening(this.Storage);
            }

            return this;
        }
    }, {
        key: '_rebind',
        value: function _rebind() {
            this._unbind();
            this._bind();
        }
    }, {
        key: '_updateStorage',
        value: function _updateStorage() {
            return this.setState(this._getState());
        }
    }]);

    return ConnectCollection;
}(_eventEmitter2.default);

var connectFabric = function connectFabric(Component, Storage) {
    var _class, _temp3;

    if (typeof Component !== 'function') {
        if (process && process.env.NODE_ENV !== 'production') {
            console.error('ConnectCollection: cannot connect Constructor.');
        }

        return null;
    }

    return _temp3 = _class = function (_ConnectCollection) {
        _inherits(_class, _ConnectCollection);

        function _class() {
            var _ref2;

            var _temp2, _this2, _ret2;

            _classCallCheck(this, _class);

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref2, [this].concat(args))), _this2), _this2.ComponentToWrap = Component, _this2.Storage = Storage, _temp2), _possibleConstructorReturn(_this2, _ret2);
        }

        return _class;
    }(ConnectCollection), _class.displayName = 'ConnectCollection(' + (Component.displayName || '') + ')', _temp3;
};